<template>
  <div class="main MytaskMain">
    <!-- 上部分 -->
    <div class="title">
      <span class="text">站内信</span>
    </div>
    <!-- 下部分 -->
    <!-- 表格 -->
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 99%;height: 530px;overflow-y: scroll;"
        :header-row-style="{color: '#666'}"
      >
        <el-table-column align="center" prop="orderNumber" label="序号" width="100" type="index" :index="increamentIndex"></el-table-column>
        <el-table-column align="center" prop="title" label="标题"></el-table-column>
        <el-table-column align="center" prop="content" label="内容"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button round size="mini" type="success" @click="downloadFile(scope.row)">附件下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'
import config from '../config'

const { downloadUrl } = config

export default {
  data () {
    return {
      downloadUrl,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      id: ''
    }
  },
  mounted () {
    this.asyncGetMsgForMem()
  },
  methods: {
    // 序号自增
    increamentIndex (index) {
      return index + (this.currentPage - 1) * this.pageSize + 1
    },
    asyncGetMsgForMem () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.id = resp.data.id
          let _params = {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            membershipid: this.id
          }
          API.getMsgForMem(_params).then(resp => {
            if (resp.resultCode === '0000') {
              this.tableData = resp.data.list
              this.total = resp.data.total
            }
          })
        }
      })
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.asyncGetMsgForMem()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.asyncGetMsgForMem()
    },
    downloadFile (item) {
      if (item.file) {
        window.open(this.downloadUrl + item.file)
      } else {
        this.$message.error('该站内信未添加附件')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.MytaskMain{
  .el-button--success{
    background-color: #009688;
    color: #fff;
    border: 0;
  }
}
</style>
